import { Skeleton, Space } from 'antd';
import React from 'react';

const TableSkeleton = ({ active, style }) => {
  return (
    <div style={style}>
      <Space direction="vertical">
        <Skeleton avatar={{ shape: 'circle' }} paragraph={false} />
        <br />
        <Space>
          <Skeleton.Input active={active} size="small" style={{ width: 300 }} />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
        </Space>
        <Space>
          <Skeleton.Input active={active} size="small" style={{ width: 300 }} />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
        </Space>
        <Space>
          <Skeleton.Input active={active} size="small" style={{ width: 300 }} />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
        </Space>
        <Space>
          <Skeleton.Input active={active} size="small" style={{ width: 300 }} />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
          <Skeleton.Input active={active} size="small" />
        </Space>
      </Space>
    </div>
  );
};

export default TableSkeleton;
